import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import "@virtual-cinema/client-lib/dist/client-lib-styles.css"
import "./App.css";
import { Box, Container } from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { UserContext } from "./user-context";
import { ViewContent } from "./components/view-content";
import LandingPage from "./components/landing-page";
import { MyTickets } from "./components/my-tickets";
import ViewEvent from "./components/view-event";
import PaymentReturnPage from "./components/payment_return_page";
import ProfilePage from "./components/profile-page";
import SignupPage from "./components/signup-page";
import LoginPage from "./components/login-page";
import ForgotPasswordPage from "./components/forgot-password-page";
import { NotFoundPage, ThemeProvider, Footer, AuthenticationGuard } from '@virtual-cinema/client-lib';

const App = ({ children }) => {
  const [user, setUser] = useState(null);

  return (
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh', // Ensure the Box takes at least the full viewport height
          }}
        >
          <UserContext.Provider value={user}>
            <Box sx={{ flex: 1 }}> {/* This Box will grow to push the footer down */}
              <Routes>
                {/* Public routes */}
                <Route path="/" element={<LandingPage />} />
                <Route path="/signup" element={<SignupPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/event/:id" element={<ViewEvent />} />
                <Route path="/event/:eventId/content/:contentId" element={<ViewContent />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />


                {/* Protected routes */}
                <Route path="/myTickets" element={<AuthenticationGuard component={MyTickets} />} />
                <Route path="/profile" element={<AuthenticationGuard component={ProfilePage} />} />
                <Route path="/return" element={<AuthenticationGuard component={PaymentReturnPage} />} />

                {/* Add the catch-all route for 404 Not Found */}
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Box>
            <Container maxWidth="xl">
              <Footer />
            </Container>
          </UserContext.Provider>
        </Box>
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default App;